import { useQuery } from "@tanstack/react-query";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import { defaultCompare } from "logic/DefaultCompare";
import OptionParameter from "enterprise/parameters/components/option/OptionParameter";
const retrieveFieldValuesFor = (parameter, searchId) => fetch("POST", qualifyUrl(`/plugins/org.graylog.plugins.enterprise/fieldvalues/${searchId}`), {
  parameter: parameter.name
});
const isOptionParameter = (parameter) => parameter.type === OptionParameter.type;
const retrieveValuesOf = (parameter, searchId) => {
  if (!isOptionParameter(parameter)) {
    throw new Error(`Invalid parameter passed, not option parameter: ${parameter}`);
  }
  const { source } = parameter;
  switch (source.type) {
    case "field":
      return retrieveFieldValuesFor(parameter, searchId).then((values) => values.sort(defaultCompare));
    case "static":
      return Promise.resolve(source.values);
    default:
      throw new Error(`Invalid option source type: ${source.type}`);
  }
};
const useValuesOf = (parameter, searchId) => useQuery({
  queryKey: ["fieldValues", searchId, parameter.name],
  queryFn: () => retrieveValuesOf(parameter, searchId)
});
export default useValuesOf;
